// src/components/GlobalBubbles.jsx
import React, { useMemo } from "react";
import "../App.css";

export default function GlobalBubbles() {
  const bubbleCount = 50;

  const bubbles = useMemo(() => {
    const arr = [];
    for (let i = 0; i < bubbleCount; i++) {
      const size = 1 + Math.random() * 10; // 🔥 1px–5px only
      const left = Math.random() * 100;
      const top = Math.random() * 100;
      const duration = 10 + Math.random() * 20;
      const delay = Math.random() * 6;
      const opacity = 0.5 + Math.random() * 0.5;

      arr.push({ id: i, size, left, top, duration, delay, opacity });
    }
    return arr;
  }, []);

  // return (
  //   <div className="global-bubbles" aria-hidden="true">
  //     {bubbles.map((b) => (
  //       <span
  //         key={b.id}
  //         className="bubble"
  //         style={{
  //           width: `${b.size}px`,
  //           height: `${b.size}px`,
  //           left: `${b.left}%`,
  //           top: `${b.top}%`,
  //           opacity: b.opacity,
  //           animation: `float ${b.duration}s ease-in-out ${b.delay}s infinite alternate,
  //                       drift ${b.duration / 2}s ease-in-out ${b.delay}s infinite`,
  //         }}
  //       />
  //     ))}
  //   </div>
  // );
}
